var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("div", [
          _c("article", { staticClass: "box" }, [
            _c("div", { staticClass: "columns" }, [
              _vm._m(0),
              _c("div", { staticClass: "column is-narrow" }, [
                _c("div", { staticClass: "dropdown is-right is-hoverable" }, [
                  _vm._m(1),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      attrs: { id: "dropdown-menu-pnet", role: "menu" },
                    },
                    [
                      _c("div", { staticClass: "dropdown-content" }, [
                        _vm.isSubmitQuoteEnabled
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "dropdown-item dropdown-item-has-icon",
                                class: {
                                  "is-disabled":
                                    !_vm.$company.setting.estimageOnlineEnabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openSendQuoteModal()
                                  },
                                },
                              },
                              [
                                _vm._m(2),
                                _c(
                                  "span",
                                  { staticClass: "dropdown-item-text" },
                                  [_vm._v("Submit Quote")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.isSubmitInvoiceEnabled
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "dropdown-item dropdown-item-has-icon",
                                class: {
                                  "is-disabled":
                                    !_vm.$company.setting.estimageOnlineEnabled,
                                },
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openSendInvoiceModal()
                                  },
                                },
                              },
                              [
                                _vm._m(3),
                                _c(
                                  "span",
                                  { staticClass: "dropdown-item-text" },
                                  [_vm._v("Submit Tax Invoice")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item dropdown-item-has-icon",
                            class: {
                              "is-disabled":
                                !_vm.$company.setting.estimageOnlineEnabled,
                            },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.updateVehicle()
                              },
                            },
                          },
                          [
                            _vm._m(4),
                            _c("span", { staticClass: "dropdown-item-text" }, [
                              _vm._v("Update Vehicle Details"),
                            ]),
                          ]
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item dropdown-item-has-icon",
                            class: {
                              "is-disabled":
                                !_vm.$company.setting.estimageOnlineEnabled,
                            },
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.openUploadImageModal()
                              },
                            },
                          },
                          [
                            _vm._m(5),
                            _c("span", { staticClass: "dropdown-item-text" }, [
                              _vm._v("Upload images"),
                            ]),
                          ]
                        ),
                        _c("hr", { staticClass: "dropdown-divider" }),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item dropdown-item-has-icon",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.viewMessages()
                              },
                            },
                          },
                          [
                            _vm._m(6),
                            _c("span", { staticClass: "dropdown-item-text" }, [
                              _vm._v("View Messages"),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            !_vm.$company.setting.estimageOnlineEnabled
              ? _c(
                  "div",
                  { staticClass: "notification is-warning" },
                  [
                    _c("p", [
                      _vm._v(
                        " Estimage is not set up for communication between FlexiQuote and EstImage. "
                      ),
                    ]),
                    _vm.$user.info.isCustomerAdministrator ||
                    _vm.$user.info.isSupportUser ||
                    _vm.$user.info.isSystemAdministrator
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "CompanyIntegrationSetting",
                                params: { defaultActiveTabIndex: 9 },
                              },
                            },
                          },
                          [_vm._v("Set up EstImage")]
                        )
                      : _c("div", [
                          _vm._v(
                            "We highly recommend contacting FlexiQuote Administrator to enable the integration."
                          ),
                        ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "article",
            { staticClass: "box" },
            [
              _c("p", { staticClass: "title" }, [_vm._v("Remarks")]),
              _c(
                "bulma-table",
                {
                  staticClass:
                    "table is-bordered is-striped is-narrow is-fullwidth",
                  attrs: {
                    columns: _vm.columns,
                    "page-index": _vm.filter.pageIndex,
                    "page-size": _vm.filter.pageSize,
                    "total-rows": _vm.remarkTotalRows,
                    "is-loading": _vm.isTableLoading,
                    "sort-column": _vm.filter.sortColumn,
                    "sort-order": _vm.filter.sortOrder,
                    "show-header": false,
                  },
                  on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                },
                [
                  _vm._l(_vm.pagedRemarks, function (remark, index) {
                    return _c(
                      "tr",
                      {
                        key: remark.remarkId,
                        on: {
                          click: function ($event) {
                            return _vm.highlightSelected(index, $event)
                          },
                        },
                      },
                      [
                        _c("td", { staticClass: "is-content-width" }, [
                          _c("span", { staticClass: "tag is-info" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatDateTimeLocale(
                                  remark.remarkDateTime,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("td", { staticClass: "is-remark" }, [
                          _c("div", [_vm._v(_vm._s(remark.remarks))]),
                        ]),
                      ]
                    )
                  }),
                  _c("template", { slot: "empty" }, [
                    _c("section", { staticClass: "section" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content has-text-grey has-text-centered",
                        },
                        [
                          _c("span", { attrs: { icon: "icon is-large" } }, [
                            _c("i", {
                              staticClass: "mdi mdi-48px mdi-emoticon-sad",
                            }),
                          ]),
                          _c("p", [_vm._v("Nothing")]),
                        ]
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm.isSendQuoteModalActive
        ? _c("est-image-send-quote-modal", {
            attrs: {
              active: _vm.isSendQuoteModalActive,
              value: _vm.innerValue,
              "modal-type": _vm.modalType,
              title: _vm.modalTitle,
              "icon-name": "mdi-upload",
            },
            on: {
              "update:active": function ($event) {
                _vm.isSendQuoteModalActive = $event
              },
              close: _vm.closeModal,
              submit: _vm.submit,
            },
          })
        : _vm._e(),
      _vm.isXmlViewerModalActive
        ? _c(
            "xml-viewer-modal",
            {
              attrs: {
                active: _vm.isXmlViewerModalActive,
                "quote-id": _vm.value.quoteId,
                "message-type": _vm.messageType,
                "page-size": 10,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isXmlViewerModalActive = $event
                },
                close: function ($event) {
                  _vm.isXmlViewerModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("View " + _vm._s(_vm.messageType) + " Messages"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isMessageModalActive
        ? _c(
            "bulma-message",
            {
              attrs: {
                value: _vm.isMessageModalActive,
                title: _vm.messageTitle,
                type: _vm.bulmaMessageType,
              },
              on: {
                close: function ($event) {
                  _vm.isMessageModalActive = false
                },
              },
            },
            [
              _c("p", {
                staticClass: "is-size-6 mt-2",
                domProps: { innerHTML: _vm._s(_vm.notificationTitle) },
              }),
              _c("br"),
              _c("notification-box", {
                staticClass: "mt-3",
                attrs: { type: _vm.notificationType },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "text-content",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "container" }, [
                            _c("div", { staticClass: "columns" }, [
                              _c("div", { staticClass: "column" }, [
                                _c("p", {
                                  staticClass: "is-size-6",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.notificationMessage),
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1185385178
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("EstImage")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dropdown-trigger" }, [
      _c(
        "button",
        {
          staticClass: "button",
          attrs: {
            "aria-haspopup": "true",
            "aria-controls": "dropdown-menu-pnet",
          },
        },
        [
          _c("span", [_vm._v("EstImage")]),
          _c("span", { staticClass: "icon is-small" }, [
            _c("i", {
              staticClass: "mdi mdi-chevron-down",
              attrs: { "aria-hidden": "true" },
            }),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-upload mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-currency-usd mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-car mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon is-small is-left has-text-primary" },
      [_c("i", { staticClass: "mdi mdi-image-multiple mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "icon is-small is-left has-text-primary",
        staticStyle: { "self-align": "center" },
      },
      [_c("i", { staticClass: "mdi mdi-file-code mdi-18px" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }